var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RiskCalculationWithTable',{attrs:{"major-risk-num":0,"minor-risk-num":1,"ofi-risk-num":2,"un-answer-num":0,"result-list":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }